var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#list_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 7,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 7,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 8,
    width: 7,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 14,
    height: 2,
    rx: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "list_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgList;